import React, { createContext } from 'react';

const AICreatorContext = createContext();

export default AICreatorContext;